import { FormControl, FormGroup, Validators } from '@angular/forms';
import { passwordValidator } from '../../shared/validators/password.validator';

export class ChangePasswordForm extends FormGroup {
  constructor() {
    super({
      newPassword: new FormControl('', [Validators.required, passwordValidator()]),
      verificationState: new FormControl('', [Validators.required]),
      email: new FormControl('', [Validators.required, Validators.email])
    });
  }

  get verificationState(): FormControl {
    return this.get('verificationState') as FormControl;
  }

  get newPassword(): FormControl {
    return this.get('newPassword') as FormControl;
  }

  get email(): FormControl {
    return this.get('email') as FormControl;
  }
}
